<template>
  <div>
    <Tab
      v-for="(level, index) in templateData.level"
      :key="index"
      :tabs="dataList[index]"
      :lvl="index"
      @activeTabChange="tabChange"
    >
    </Tab>
  </div>
</template>

<script>
const momentTz = require('moment-timezone');
import { EventBus } from "@/services/event-bus";
import groupArray from "group-array";
import moment from "moment";
import CustomReport from "@/services/customReport";

import { mapGetters } from "vuex";
import Tab from "./Tab";

export default {
  components: {
    Tab,
  },
  props: {
    templateData: {
      type: Object,
    },
    dateFormat: String,
  },
  data() {
    return {
      loading: false,
      deviceIdMap: {},
      dataList: [],
      view: "table",
      options: {
        yAxis: [],
        xAxis: [],
        series: [],
      },
      tableData: [],
      header: [],
      apiCounter: 0,
      activeLevel: null,
      timeout: {},
    };
  },
  async mounted() {
    EventBus.$on("download:report", this.initiateDownload);
    EventBus.$on("download:immediateReport", this.initiateDownloadImmediate);
    EventBus.$on("reload:report", this.refreshTable);
    await this.initialFunction(0, 0, this.templateData.level[0]["func"]);
  },
  beforeDestroy() {
    EventBus.$off("download:report", this.initiateDownload);
    EventBus.$off("download:immediateReport", this.initiateDownloadImmediate);
    EventBus.$off("reload:report", this.refreshTable);
  },
  computed: {
    ...mapGetters("report", ["getSelectedTemplate"]),
    ...mapGetters([
      "getSelectedPlantId",
      "getActivePlantInfo",
      "getGeneralState",
    ]),
    currentLanguage() {
      return this.getGeneralState('language')
    },
    activeFilter() {
      return this.getGeneralState("activeFilterOption");
    },
    activeTab: {
      get() {
        let actTab = this.templateData.level.map((el) => 0);
        actTab.pop();
        return actTab;
      },
      set(value) {
        if (value) {
          return value;
        }
      },
    },
  },
  methods: {
    computeParam(initialTab = true) {
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getActivePlantInfo("plant_name"),
        template: this.getSelectedTemplate.template,
        view: initialTab ? this.view : "table",
        type: this.activeFilter["selectedRange"].interval,
      };
      if (this.activeFilter["selectedRange"].interval === "custom") {
        if (
          moment(this.activeFilter.Date.from)
            .startOf("month")
            .format("YYYY-MM-DD") == this.activeFilter.Date.from &&
          moment(this.activeFilter.Date.to)
            .startOf("month")
            .format("YYYY-MM-DD") == this.activeFilter.Date.to &&
          moment(this.activeFilter.Date.to).diff(
            this.activeFilter.Date.from,
            "months"
          ) >= 1
        ) {
          param.type = "monthly";
          param.dateFrom = moment(this.activeFilter.Date.from).format(
            "YYYY-MM-00"
          );
          param.dateTo = moment(this.activeFilter.Date.to)
            .subtract(1, "months")
            .format("YYYY-MM-00");
        } else {
          param.dateFrom = this.activeFilter.Date.from;
          param.dateTo = this.activeFilter.Date.to;
        }
      }

      if (this.activeFilter["selectedRange"].interval === "daily") {
        if (this.activeFilter["selectedRange"].offsetLevel === "month") {
          param.dateFrom = momentTz().tz(this.getActivePlantInfo("timezone"))
            .subtract(
              this.activeFilter["selectedRange"].startOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .startOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
          param.dateTo = momentTz().tz(this.getActivePlantInfo("timezone"))
            .subtract(
              this.activeFilter["selectedRange"].endOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .endOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
        } else {
          param.dateFrom = momentTz().tz(this.getActivePlantInfo("timezone"))
            .subtract(this.activeFilter["selectedRange"].startOffset, "day")
            .format("YYYY-MM-DD");
          param.dateTo = momentTz().tz(this.getActivePlantInfo("timezone"))
            .subtract(this.activeFilter["selectedRange"].endOffset, "day")
            .format("YYYY-MM-DD");
        }
      } else if (this.activeFilter["selectedRange"].interval === "monthly") {
        let format = initialTab
          ? {
              dateFrom: "YYYY-MM-00",
              dateTo: "YYYY-MM-00",
            }
          : {
              dateFrom: "YYYY-MM-DD",
              dateTo: "YYYY-MM-DD",
            };
        param.dateFrom = momentTz().tz(this.getActivePlantInfo("timezone"))
          .subtract(
            this.activeFilter["selectedRange"].startOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .startOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format["dateFrom"]}`);
        param.dateTo = momentTz().tz(this.getActivePlantInfo("timezone"))
          .subtract(
            this.activeFilter["selectedRange"].endOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .endOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format["dateTo"]}`);
      } else if (
        this.activeFilter["selectedRange"].interval === "hourly" ||
        this.activeFilter["selectedRange"].interval === "minute"
      ) {
        param.dateFrom = this.activeFilter.Date.from;
        param.dateTo = this.activeFilter.Date.to;
        param.interval = this.activeFilter["selectedRange"].intervalGap
          ? this.activeFilter["selectedRange"].intervalGap
          : 1;
      }
      return param;
    },
    tabChange(values) {
      const { level, tab } = values;
      this.resetDataList(level);
      this.$emit("loading:report", this.loading);
      this.initialFunction(level, tab, this.templateData.level[level]["func"]);
    },
    resetDataList(level) {
      for (let i = level + 1; i < this.templateData.level.length - 1; i++) {
        this.$set(this.dataList, i, undefined);
      }
    },
    initialFunction(level, activeTab, funcName) {
      const functionMap = {
        loadStaticTab: this.loadStaticTab,
        loadSummaryTab: this.loadConfiguredSummaryTab,
        fetchBlocks: this.fetchBlocks,
        loadConfiguredTab: this.loadEquipment,
        loadBlockWiseEquipment: this.loadBlockWiseEquipment,
        loadEquipment: this.loadEquipment,
        loadDevice: this.loadDevices,
        loadSummaryData: this.loadSummaryData,
      };
      this.debounce(functionMap[funcName], 1000, funcName)(level, activeTab);
    },
    loadStaticTab(level, activeTab) {
      this.activeTab[level] = activeTab;
      this.loadData(level);
    },
    loadConfiguredSummaryTab(level, activeTab) {
      this.loading = true;
      this.activeTab[level] = activeTab;
      let param = this.computeParam(false);
      if (this.dataList.length == 0) {
        CustomReport.fetchConfigureDevice({
          plantId: this.getSelectedPlantId,
          template: this.templateData.value,
        })
          .then((result) => {
            this.loading = false;
            this.$set(this.dataList, level, [...result.data]);
            param.device = this.dataList[level][this.activeTab[level]];
            param.sheet = "device";
            CustomReport.fetchSummary(param).then((result) => {
              this.loading = false;
              const { data } = result;
              this.$emit("table:data", data);
              this.$emit("view", "table");
            });
          })
          .catch((err) => {
            this.loading = false;
            console.log(err, "ERROR");
            this.$emit("table:data", {
              data: [],
              headers: [],
            });
            this.$emit("view", "table");
          });
      } else if (this.dataList[level] != undefined) {
        param.device = this.dataList[level][this.activeTab[level]];
        param.sheet = "device";
        CustomReport.fetchSummary(param)
          .then((result) => {
            const { data } = result;
            this.loading = false;
            this.$emit("table:data", data);
            this.$emit("view", "table");
          })
          .catch((err) => {
            this.loading = false;
            this.$emit("table:data", {
              data: [],
              headers: [],
            });
            this.$emit("view", "table");
          });
      }
    },
    fetchBlocks(level, active) {
      // if first level is not loaded
      this.loading = true;
      if (this.dataList[level] != undefined) {
        this.activeTab[level] = active;
        this.loadBlockWiseEquipment(level + 1, active);
      } else {
        this.activeTab[level] = active;
        CustomReport.fetchBlock({
          plantId: this.getSelectedPlantId,
        })
          .then((result) => {
            this.loading = false;
            this.$set(this.dataList, level, [
              ...result.data.map((el) => {
                let tempObj = {};
                tempObj["name"] = el.block_name;
                tempObj["id"] = el.block_id;
                return tempObj;
              }),
            ]);

            if (this.dataList[level] != undefined) {
              this.loadBlockWiseEquipment(level + 1, active);
            }
          })
          .catch((err) => (this.loading = false));
      }
    },
    loadEquipment(level, active) {
      this.loading = true;
      if (this.dataList[level] == undefined) {
        this.activeTab[level] = 0;
        CustomReport.fetchConfigureDevice({
          plantId: this.getSelectedPlantId,
          template: this.templateData.value,
        })
          .then((result) => {
            this.loading = false;
            this.$set(this.dataList, level, [...result.data]);
            this.loadDevices(level, this.activeTab[level]);
          })
          .catch((err) => (this.loading = false));
      } else {
        this.activeTab[level] = active;
        this.loadDevices(level, this.activeTab[level]);
      }
    },
    async loadDevices(level, active) {
      let paramTemp = {};
      let levelOffset = 0;
      this.loading = true;
      if (this.templateData.level.length - 2 != level) {
        levelOffset = 1;
      }
      if (this.dataList[level + levelOffset] == undefined) {
        this.activeTab[level + levelOffset] = 0;
      } else {
        this.activeTab[level + levelOffset] = active;
      }
      paramTemp["plantId"] = this.getSelectedPlantId;
      paramTemp["device"] =
        this.dataList[this.templateData.deviceTabIndex][this.activeTab[level]];

      if (this.dataList[level - 1] !== undefined) {
        paramTemp["blockId"] =
          this.dataList[level - 1][this.activeTab[level - 1]].id;
      }

      if (
        this.dataList[level + levelOffset] == undefined &&
        this.templateData.level.length - 2 != level
      ) {
        await CustomReport.fetchDevice(paramTemp)
          .then((result) => {
            this.loading = false;
            this.deviceMap = result.data;
            this.deviceIdMap = {};
            Object.keys(result.data).forEach((key) => {
              this.deviceIdMap[result.data[key]] = key;
            });
            this.$set(
              this.dataList,
              this.templateData.deviceTabIndex + 1,
              Object.values(result.data)
            );
          })
          .catch((err) => (this.loading = false));
        this.activeLevel = active;
      }

      if (this.dataList[this.templateData.deviceTabIndex + 1] != undefined) {
        this.loadSummaryData(
          level,
          this.activeTab[level],
          this.dataList[this.templateData.deviceTabIndex][
            this.activeTab[this.templateData.deviceTabIndex]
          ],
          this.dataList[this.templateData.deviceTabIndex + 1]
        );
      }
    },
    loadBlockWiseEquipment(level, activeTab) {
      this.loading = true;
      if (this.dataList[level] == undefined) {
        this.activeTab[level] = 0;
        let param = {};
        param["plantId"] = this.getSelectedPlantId;
        param["blockId"] =
          this.dataList[level - 1][this.activeTab[level - 1]].id;
        CustomReport.fetchDevice(param)
          .then((result) => {
            this.loading = false;
            let devicesAvail = result.data.map((el) => el["device_name"]);
            this.deviceIdMap = result.data;
            this.$set(this.dataList, level, [...new Set(devicesAvail)]);

            if (this.dataList[level] != undefined) {
              this.loadDevices(level, this.activeTab[level]);
            }
          })
          .catch((err) => (this.loading = false));
      } else {
        this.activeTab[level] = activeTab;
        this.loadDevices(level, this.activeTab[level]);
      }
    },
    loadSummaryData(level, activeTab, equipment, deviceTab) {
      let param = this.computeParam(false);
      this.loading = true;
      let obj = {
        "energy meter": 2,
        inverter: 3,
        mfm: 2,
        scb: 4,
        "weather station": 2,
      };

      let deviceName =
        deviceTab[this.activeTab[this.templateData.level.length - 2]];
      param.device = equipment;
      param.deviceId = this.deviceIdMap[deviceName];

      let deviceIdMap = {};
      deviceIdMap[`${param.deviceId}`] = deviceName;
      param.deviceNamesMap = {
        ...deviceIdMap,
      };
      param.level = obj[param.device];

      CustomReport.fetchSummary(param)
        .then((result) => {
          this.loading = false;
          const { data } = result;
          this.$emit("table:data", data);
          this.$emit("view", "table");
        })
        .catch((err) => {
          this.loading = false;
          this.$emit("table:data", {
            data: [],
            headers: [],
          });
          this.$emit("view", "table");
        });
    },
    loadData(level) {
      this.view = this.activeTab[level] == 1 ? "table" : "graph";
      let param = this.computeParam();

      if (this.view == "graph") {
        if (this.apiCounter == 0) {
          this.$set(this.dataList, 0, ["GRAPHICAL REPORTS", "TABULAR REPORTS"]);
        } else {
          EventBus.$emit("reset:graph");
        }
      }

      if (
        (this.view == "graph" && this.apiCounter == 0) ||
        (this.view == "table" && this.apiCounter == 0)
      ) {
        this.loading = true;
        CustomReport.fetchData(param)
          .then((result) => {
            this.loading = false;
            const { data, optMsg } = result.data;

            this.apiCounter++;
            const idName = optMsg;
            this.graphTransLogic(data, idName);
            this.tableTransLogic(data, idName);
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.apiCounter++;
            if (this.view === "graph") {
              this.$emit("graph:data", {
                yAxis: [],
                xAxis: [],
                series: [],
              });
            } else if (this.view === "table") {
              this.$emit("table:data", {
                data: [],
                header: [],
              });
              this.$emit("view", this.view);
            }
          });
      } else if (this.apiCounter > 0) {
        this.$emit("view", this.view);
      }
    },
    tableTransLogic(data, idName) {
      let newResult = [];
      let modifiedResult = [];

      const plantLevelShow = {
        inverter: "INV",
        "energy meter": "EM",
        mfm: "MFM",
      };

      data.forEach((res, index) => {
        let obj = {};
        let device = "";
        let switchLevel = res.new_level;
        switch (switchLevel) {
          case 0:
            if (res["device"] !== "weather station") {
              device = plantLevelShow[res["device"]]
                ? `${plantLevelShow[res["device"]]} GEN (kWh)`
                : `${res["device"]} GEN (kWh)`;
            } else {
              device = res["name"];
            }
            break;
          case 1:
            let entry = {};
            for (const [key, value] of Object.entries(idName[res["device"]])) {
              entry[key.split("-")[0]] = value.split("-")[0];
            }
            device = `${entry[`${res["device_id"]}`]} (kWh)`;
            break;
          default:
            device = `${idName[res["device"]][res["device_id"]]} (kWh)`;
            break;
        }

        obj[device] = isNaN(parseFloat(res["value"]))
          ? res["value"]
          : parseFloat(res["value"]).toFixed(2);
        obj["device"] = res["device"];
        obj["date_frame"] = res["date_frame"];
        obj["dates"] = res["std_date"];
        obj["new_level"] = res["new_level"];
        newResult.push(obj);
      });

      let level = null;
      let device = "";
      let swapData = newResult.map((el) => {
        if (el["device"] != "weather station") {
          level = el["new_level"];
          device = el["device"];
        }
        return Object.keys(el)[0];
      });

      let header = [
        {
          key: "Date",
          value: "date_frame",
        },
      ];

      let tempHeader;
      let mySet = Array.from(new Set(swapData));
      if (level > 1) {
        tempHeader = Object.values(idName[device])
          .map((e) => e + " (kWh)")
          .filter((el) => {
            return mySet.includes(el);
          });
      } else if (level == 1) {
        tempHeader = Array.from(
          new Set(
            Object.values(idName[device]).map(
              (el) => `${el.split("-")[0]} (kWh)`
            )
          )
        ).filter((el) => {
          return mySet.includes(el);
        });
      } else {
        tempHeader = [...mySet];
      }
      if (level > 0) {
        tempHeader.push("POA Insolation (kWh/m²)");
        if (
          (this.activeFilter.Date &&
            moment(this.activeFilter.Date.to).diff(
              moment(this.activeFilter.Date.from),
              "days"
            ) == 0 &&
            this.activeFilter["selectedRange"].text == "Custom") ||
          (this.activeFilter["selectedRange"].startOffset ==
            this.activeFilter["selectedRange"].endOffset &&
            this.activeFilter["selectedRange"].interval == "daily")
        ) {
          tempHeader.push("POA (W/m²)");
        }
      }
      tempHeader.forEach((e) => {
        header.push({
          key: e,
          value: e,
        });
      });

      const groupResult = groupArray(newResult, "dates");
      Object.keys(groupResult).forEach((date) => {
        let modResult = {};
        modResult["date_frame"] = date;
        let tempHeader = [];
        header.forEach((e, i) => {
          if (i > 0) {
            tempHeader.push(e.value);
          }
        });

        groupResult[date].forEach((res) => {
          let resKey = Object.keys(res);
          let found = tempHeader.find((val) => resKey.includes(val));

          modResult[found] = res[found];
        });
        modifiedResult.push(modResult);
      });

      let tempObj = {};
      header.forEach((e, i) => {
        let deviceParam = "POA Insolation (kWh/m²)";
        if (i > 0) {
          let computedTotal = 0;
          modifiedResult.forEach((r) => {
            let val = isNaN(parseFloat(r[e.value]))
              ? 0
              : parseFloat(r[e.value]);
            // if (e.value == deviceParam || e.value == "POA (W/m²)") {
            // let diff =
            //   this.activeFilter.Date &&
            //   moment(this.activeFilter.Date.to).diff(
            //     moment(this.activeFilter.Date.from),
            //     "days"
            //   );
            // if (
            //   diff > 0 ||
            //   (this.activeFilter["selectedRange"].startOffset !=
            //     this.activeFilter["selectedRange"].endOffset &&
            //     this.activeFilter["selectedRange"].interval == "daily") ||
            //   this.activeFilter["selectedRange"].interval != "daily"
            // ) {
            computedTotal += val;
            // } else {
            //   computedTotal = val;
            // }
            // } else {
            //   computedTotal += val;
            // }
          });

          if (e.value == "POA (W/m²)") {
            computedTotal = parseFloat(
              computedTotal / modifiedResult.length
            ).toFixed(2);
          }

          tempObj[e.value] = parseFloat(computedTotal).toFixed(2);
        } else {
          tempObj[e.value] = "Total";
        }
      });
      modifiedResult.push(tempObj);

      this.tableData = [...modifiedResult];
      this.header = header;
      this.$emit("table:data", {
        data: [...modifiedResult],
        header,
      });
      this.$emit("veiw", this.view);
    },
    graphTransLogic(data, idName) {
      const series = [];
      const axis = new Set();

      const graphVar = {
        "energy meter": "EM",
        mfm: "MFM",
        inverter: "INV",
      };

      const groupResult = groupArray(data, ["level", "name", "std_date"]);
      Object.keys(groupResult).forEach((level) => {
        Object.keys(groupResult[level]).forEach((parameters, index) => {
          const seriesStructure = {
            type: "bar",
            large: true,
            data: [],
          };
          Object.keys(groupResult[level][parameters]).forEach((date_frame) => {
            axis.add(date_frame);
            if (
              groupResult[level][parameters][date_frame][0].device !==
              "weather station"
            ) {
              seriesStructure["type"] = "bar";
            } else {
              if (parameters == "POA Insolation (kWh/m²)") {
                seriesStructure["yAxisIndex"] = 1;
              }
              seriesStructure["type"] = "line";
            }
            let tempData = isNaN(
              parseFloat(groupResult[level][parameters][date_frame][0].value)
            )
              ? groupResult[level][parameters][date_frame][0].value
              : parseFloat(
                  groupResult[level][parameters][date_frame][0].value
                ).toFixed(2);
            seriesStructure.data.push(tempData);
            let device = "";
            let switchLevel =
              groupResult[level][parameters][date_frame][0].new_level;
            switch (switchLevel) {
              case 0:
                if (
                  groupResult[level][parameters][date_frame][0].device !=
                  "weather station"
                ) {
                  device = graphVar[
                    groupResult[level][parameters][date_frame][0].device
                  ]
                    ? `${
                        graphVar[
                          groupResult[level][parameters][date_frame][0].device
                        ]
                      } GEN (kWh)`
                    : `${groupResult[level][parameters][date_frame][0].device} GEN (kWh)`;
                } else {
                  device = groupResult[level][parameters][date_frame][0].name;
                }
                break;
              case 1:
                let entry = {};
                for (const [key, value] of Object.entries(
                  idName[groupResult[level][parameters][date_frame][0].device]
                )) {
                  entry[key.split("-")[0]] = value.split("-")[0];
                }
                device = `${entry[level]} (kWh)`;
                break;
              default:
                device = `${
                  idName[groupResult[level][parameters][date_frame][0].device][
                    groupResult[level][parameters][date_frame][0].device_id
                  ]
                } (kWh)`;
                break;
            }
            seriesStructure.name = device;
          });
          series.push(seriesStructure);
        });
      });
      let xAxis = Array.from(axis).sort((a, b) => moment(a).diff(b));
      this.options.series = series;
      this.options.xAxis = xAxis;
      this.options.yAxis.push(
        ...[
          {
            name: "Generation (kWh)",
            type: "value",
            position: "left",
          },
          {
            name: "POA Insolation (kWh/m²)",
            type: "value",
            position: "right",
          },
        ]
      );

      this.$emit("graph:data", this.options);
      this.$emit("view", this.view);
    },
    initiateDownload() {
      if (
        this.dataList[this.templateData.level.length - 2].length > 1 &&
        this.getSelectedTemplate.level.length > 2
      ) {
        return EventBus.$emit(
          "open:downloadDialog",
          this.dataList[this.templateData.level.length - 2]
        );
      } else {
        return this.downloadReport();
      }
    },
    initiateDownloadImmediate(val) {
      this.downloadReport(val);
    },
    downloadReport(val = []) {
      this.loading = true;
      const param = this.computeParam(false);
      param.dateFormat = this.dateFormat;
      let obj = {
        "energy meter": 2,
        inverter: 3,
        mfm: 2,
        "weather station": 2,
        scb: 4,
      };

      let selectedId = [];
      if (val.length > 0) {
        selectedId = [...val];
      } else {
        selectedId = this.dataList[this.templateData.level.length - 2];
      }
      if (this.getSelectedTemplate.level.length == 4) {
        let id = [];
        let deviceIdMap = {};
        let deviceIdMapping = {};
        let equipmentName =
          this.dataList[this.templateData.deviceTabIndex][
            this.activeTab[this.templateData.deviceTabIndex]
          ];
        id = selectedId.map((e) => {
          return this.deviceIdMap[e];
        });

        param.deviceId = id;
        param.device = equipmentName;
        let deviceName =
          this.dataList[this.templateData.level.length - 2][
            this.activeTab[this.templateData.deviceTabIndex]
          ];

        if (id instanceof Array) {
          id.forEach((el) => {
            selectedId.forEach((e) => {
              if (el == this.deviceIdMap[`${e}`]) {
                return (deviceIdMapping[`${el}`] = e);
              }
            });
            param.deviceNamesMap = {
              ...deviceIdMapping,
            };
          });
        } else {
          deviceIdMap[`${param.deviceId}`] = deviceName;
          param.deviceNamesMap = {
            ...deviceIdMap,
          };
        }
        param.level = obj[param.device];
        param.sheet = "device_id";

        param.view = "download";
        const paramB64 = btoa(JSON.stringify(param));
        this.chipItems = [];
        let reportName = `${this.getActivePlantInfo("plant_name")} - block level ${param.device ? param.device : ''}`;
        CustomReport.downloadSummary(paramB64, reportName)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      } else if (this.getSelectedTemplate.level.length == 3) {
        let id = [];
        let deviceIdMapping = {};
        let deviceName =
          this.dataList[this.templateData.level.length - 2][
            this.activeTab[this.templateData.deviceTabIndex]
          ];
        id = selectedId.map((e) => {
          return this.deviceIdMap[e];
        });

        param.deviceId = id;
        if (this.dataList[this.templateData.level.length - 2].length > 0) {
          this.chips = this.dataList[this.templateData.level.length - 2].map(
            (e) => e
          );
        }
        param.device =
          this.dataList[this.templateData.deviceTabIndex][
            this.activeTab[this.templateData.deviceTabIndex]
          ];
        if (id instanceof Array) {
          id.forEach((el) => {
            selectedId.forEach((e) => {
              if (el == this.deviceIdMap[`${e}`]) {
                return (deviceIdMapping[`${el}`] = e);
              }
            });
            param.deviceNamesMap = {
              ...deviceIdMapping,
            };
          });
        } else {
          deviceIdMap[`${param.deviceId}`] = deviceName;
          param.deviceNamesMap = {
            ...deviceIdMap,
          };
        }
        param.level = obj[param.device];
        param.sheet = "device_id";

        param.view = "download";
        const paramB64 = btoa(JSON.stringify(param));
        this.chipItems = [];
        let reportName = `${this.getActivePlantInfo("plant_name")} - device level ${param.device ? param.device : ''}`;
        CustomReport.downloadSummary(paramB64, reportName)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      } else if (this.getSelectedTemplate.template == "plantSummaryReport") {
        param.device = this.dataList[0];
        param.sheet = "device";
        param.view = "download";
        const paramB64 = btoa(JSON.stringify(param));
        this.chipItems = [];
        let reportName = `${this.getActivePlantInfo("plant_name")} - ${param.template ? param.template : ''}`;
        CustomReport.downloadSummary(paramB64, reportName)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      } else {
        param.view = "download";
        const paramB64 = btoa(JSON.stringify(param));
        let reportName = `${this.getActivePlantInfo("plant_name")} - ${param.template ? param.template : ''}`;
        CustomReport.downloadReport(paramB64, reportName)
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    debounce(funcRef, wait, funcName) {
      this.timeout[funcName] = wait;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(this.timeout[funcName]);
          funcRef(...args);
        };

        clearTimeout(this.timeout[funcName]);
        this.timeout[funcName] = setTimeout(later, wait);
      }.bind(this);
    },
    refreshTable() {
      this.apiCounter = 0;
      this.initialFunction(
        this.templateData.level.length - 2,
        this.activeTab[this.templateData.level.length - 2],
        this.templateData.level[this.templateData.level.length - 2]["func"]
      );
    },
  },
  watch: {
    loading() {
      this.$emit("loading:report", this.loading);
    },
    "activeFilter.Date": {
      handler() {
        this.apiCounter = 0;
        this.initialFunction(
          this.templateData.level.length - 2,
          this.activeTab[this.templateData.level.length - 2],
          this.templateData.level[this.templateData.level.length - 2]["func"]
        );
      },
      deep: true,
    },
    "activeFilter.selectedRange"() {
      this.apiCounter = 0;
      this.options.series = [];
      this.tableData = [];
      this.initialFunction(
        this.templateData.level.length - 2,
        this.activeTab[this.templateData.level.length - 2],
        this.templateData.level[this.templateData.level.length - 2]["func"]
      );
    }
  },
};
</script>
